import { Injectable } from '@jack-henry/frontend-utils/di';
import { EntitlementGroupsClient } from '@treasury/api/bo';
import { EntitlementGroup } from './entitlement-group.entity';

@Injectable()
export class EntitlementGroupsService {
    constructor(private readonly entitlementGroupsClient: EntitlementGroupsClient) {}

    public async getEntitlementGroups(): Promise<EntitlementGroup[]> {
        try {
            return (await this.entitlementGroupsClient.entitlementGroupsGet()).data.map(
                entitlementGroup => new EntitlementGroup(entitlementGroup)
            );
        } catch (error) {
            throw new Error(`Error fetching entitlement groups: ${error}`);
        }
    }
}
